// @flow

import { useMemo } from 'react';

import {
  type ProductError,
  type ProductId,
  selectOneProductById,
} from '@gandi/cart';

import { useAppSelector } from 'src/hooks';

import ProductItemBase from './ProductItemBase';
import { ErrorRow, TitleRow } from './Rows';
import { useRemoveProductHandler } from './modules';

type Props = {
  isCorporate?: boolean,

  deleteDisabled?: boolean,

  /** productId is used to be able to remove the product */
  productId?: ProductId,
  label: React.Node,
  detail?: React.Node,

  children?: React.Node,

  /** each error description will be shown */
  errors?: Array<ProductError>,
};

export default function ProductErrorItem({
  isCorporate = false,
  deleteDisabled,
  productId,
  label,
  detail,
  children,
  errors,
}: Props): React.MixedElement {
  const removeProduct = useRemoveProductHandler(productId);

  const productIdProps = useMemo(() => ({ productId }), [productId]);

  const product = useAppSelector(state =>
    // $FlowFixMe[incompatible-call] - productId can be undefined, but then no discount to display
    selectOneProductById(state, productIdProps),
  );

  return (
    <ProductItemBase>
      <TitleRow
        deleteDisabled={deleteDisabled}
        isCorporate={isCorporate}
        handleRemoveAction={removeProduct}
        label={label}
        productType={product?.productType}
        detail={detail}
      />
      {children || (
        <ErrorRow handleRemoveAction={removeProduct} errors={errors} />
      )}
    </ProductItemBase>
  );
}
